const getValue = (key) => {
  const value = localStorage && localStorage.getItem(key)
    ? JSON.parse(localStorage.getItem(key))
    : {}

  return value
}

const setValue = (key, value) => {
  if (localStorage && key){
    localStorage.setItem(key, JSON.stringify(value))
  }
}

const useLocalStorage = (key, options = {}) => ({
  callbacks: {
    getValue: () => getValue(key),
    setValue: newValue => setValue(key, newValue),
  },
  value: getValue(key),
})

export default useLocalStorage
